<ng-container *ngIf="formGroup$ | async as formGroup" [formGroup]="formGroup">
  <ng-container *ngIf="plans$ | async as plans">
    <div
      *ngIf="PGB_VIEW_MODE && plans.length === 1"
      class="ds-info mb-3"
      i18n="@@one_payment_plan_will_not_show"
    >
      Zahlungspläne mit nur einem Zahlungsplan werden Nutzern nur in bestimmten
      Ländern angezeigt.
    </div>

    <fieldset
      *ngIf="
        PGB_VIEW_MODE ||
        plans.length > 1 ||
        (plans.length > 0 && (canPreselectPlan$ | async) === false)
      "
    >
      <ng-template #defaultHeadline>
        <span i18n="@@paymentplans.title">Zahlungspläne</span>
      </ng-template>

      <legend>
        <ng-container
          *ngIf="headline$ | async as headline; else defaultHeadline"
          >{{ headline }}
        </ng-container>
      </legend>

      <ng-template #templateRef>
        <div>
          <div
            class="mb-3"
            *ngFor="let plan of plans; trackBy: trackByPlanId; let l = last"
            [attr.data-e2e]="'payment_plan:' + plan.payment_plan_id"
          >
            <ng-container>
              <ng-template #elseCheckbox>
                <!-- Do not use [type]="'checkbox'"-->
                <input
                  [id]="'plan-' + plan.payment_plan_id"
                  type="checkbox"
                  [ngClass]="{
                    'ng-valid': formGroup.valid,
                    'ng-invalid': formGroup.invalid,
                    'ng-touched': formGroup.touched
                  }"
                  (change)="
                    formGroup
                      .get('plan_id')
                      .setValue(
                        $any($event.target).checked
                          ? +plan.payment_plan_id
                          : null
                      )
                  "
                  [value]="+plan.payment_plan_id"
                  [checked]="
                    +formGroup.get('plan_id').value === +plan.payment_plan_id
                      ? true
                      : false
                  "
                />
              </ng-template>
              <input
                [id]="'plan-' + plan.payment_plan_id"
                *ngIf="plan.input_style === 'radiobutton'; else elseCheckbox"
                type="radio"
                [formControlName]="'plan_id'"
                [value]="+plan.payment_plan_id"
              />
              <label
                [ngClass]="
                  plan.input_style === 'radiobutton'
                    ? 'input-radio'
                    : 'input-checkbox'
                "
                [htmlFor]="'plan-' + plan.payment_plan_id"
              >
                <strong
                  class="mb-2 d-block"
                  [innerHTML]="plan.headline_html"
                ></strong>
                <div [innerHTML]="plan.description_html"></div>
              </label>
            </ng-container>
          </div>

          <div class="mt-3">
            <orderform-input-errors
              i18n-fieldName="@@paymentplans.error.title"
              fieldName="Zahlungspläne"
              [control]="formGroup.controls['plan_id']"
            ></orderform-input-errors>
          </div>
        </div>
      </ng-template>

      <ng-template #defaultTemplate>
        <ng-container *ngIf="plans.length > 1">
          <ng-container *ngTemplateOutlet="templateRef"></ng-container>
        </ng-container>
      </ng-template>
      <ng-container *ngIf="plans.length < 2; else defaultTemplate">
        <ng-container *ngTemplateOutlet="templateRef"></ng-container>
      </ng-container>
    </fieldset>
  </ng-container>
</ng-container>
